<div class="grid-12 arm-introduction__info">
    <div class="contact-caption arm-introduction__infomobile">
        <div class="contact-caption--caption mr-2">
            <p>
                {{ 'documentselection.documentlist.footer.contact.text.exp3' | i18n }}
            </p>
            <span>
                {{ 'documentselection.documentlist.footer.contact.info.exp3' | i18n }}
            </span>
        </div>
    </div>
</div>
